export default __webpack_public_path__ + "static/media/unmanned-aircraft.04d3b048.jpg";